import React from 'react';
import { tryDark } from "../../Markup"

const languagePageData = [
  {
    type: "Center",
    class: "short",
    title: {
      class: "medium-purple MankSans-Medium",
      text: "What is Dark?",
    },
    paragraph: [
      <p key={"Dark"} className="small-title black-text MankSans-Medium">Dark is a language for building backends. Our goal is to make coding 100x easier, which we believe will allow a billion people to build software. This is a huge challenge that requires a significant rethink...</p>,
      <a target="_blank" rel="noopener noreferrer" href="https://medium.com/darklang/the-design-of-dark-59f5d38e52d2" className="light-purple paragraph-text MankSans-Medium">Read More</a>
    ]
  },
  {
    type: "TwoColumn",
    class: "short",
    columns: [
      {
        class: "fat",
        type: "text",
        rows: [
          {
            class: "",
            title: {
              class: "medium-purple MankSans-Medium",
              text: "Functional Languages and their Influence on Dark",
            },
            paragraph: [
              <p key={""} className="paragraph-text grey-text">Static types help you ensure that your changes work, especially for changes that span large parts of the program. Dynamic types allow you to prototype quicker, and iterate faster. How can we get the best of both worlds?</p>,
              <a target="_blank" rel="noopener noreferrer" href="https://medium.com/darklang/real-problems-with-functional-languages-efe668c5264a" className="light-purple paragraph-text MankSans-Medium">Read More</a>
            ]
          }
        ]
      },
      {
        class: "skinny lavender-background",
        type: "img",
        alt: "A mockup of the Dark ErrorRail",
        src: "/functional-languages.png"
      }
    ],
  },
  {
    type: "TwoColumn",
    class: "short lrg-space-below",
    columns: [
      {
        class: "skinny lavender-background",
        type: "img",
        alt: "A deployment pipeline",
        src: "/dark-deploy-vertical.png"
      },
      {
        class: "fat",
        type: "text",
        rows: [
          {
            class: "mb-center-text",
            title: {
              class: "medium-purple MankSans-Medium",
              text: "How Dark Deploys Code in 50ms",
            },
            paragraph: [
              <p key={"Speed"} className="small-title black-text MankSans-Medium">Speed of developer iteration is the single most important factor in how quickly a technology company can move.</p>,
              <p key={""} className="paragraph-text grey-text">Unfortunately, the fastest deploys in the industry still take 5-10 minutes. Dark is designed to deploy safely in 50 milliseconds.</p>,
              <a target="_blank" rel="noopener noreferrer" href="https://medium.com/darklang/how-dark-deploys-code-in-50ms-771c6dd60671" className="light-purple paragraph-text MankSans-Medium">Read More</a>]
          }
        ]
      },
    ],
  },
  {
    type: "Faq",
    class: "dark-purple-background",
    title: {
      class: "large-title purple-white center-text MankSans-Medium",
      text: "Frequently Asked Questions"
    },
    questions: [
      {
        key: "private-beta",
        question: "What does it mean that Dark is in private beta? Why isn't Dark available to everyone?",
        answer: [
          "The primary reason that we're not opening up access fully is that we have customers who run their businesses on Dark, and so it's important that we ensure a great experience for them and their users. Our primary focus so far has been on creating the concept of Dark and proving that you can use it to build useful applications. There remains some work before Dark is ready to be open to the public, including features around scalability, privacy, compliance, and accessibility."
        ]
      },
      {
        key: "production-ready",
        question: "Is Dark Production ready? Who should use Dark today?",
        answer: [
          "Dark is in private beta, so we're not confident enough to call it production ready. We have a few dozen people using it, some for their entire businesses, so if you can tolerate some risk, Dark should be sufficiently production ready for you. Good use cases are side projects, new startups, or if you have limited time or resources. Otherwise, we suggest waiting."
        ]
      },
      {
        key: "pricing",
        question: "How much will Dark cost?",
        answer: [
          "We're still determining specifics, but Dark pricing will be based on how much infrastructure you use. We will be charging for traffic, compute, and memory usage, similar to other infrastructure. Dark will be free to start, and will gradually scale up with usage. We expect that our free tier will fully cover small projects."
        ]
      },
      // {
      //   question: "How does Dark organize code? Do I have to drag code around in Dark?",
      //   answer: [
      //     "If you've seen our launch video, you'll see that at the moment, you do have to use the mouse a little bit. We do not intend that to be the primary metaphor for how you write code in Dark, and we do not expect you to have to use the mouse much if you prefer not to."
      //   ]
      // },
      {
        key: "self-hosting",
        question: "Will I be able to run Dark myself?",
        answer: [
          "One of the ways that we remove accidental complexity is that we run Dark for you. We run the infrastructure, maintain, monitor and optimize it, and we carry the pager for it. We have not designed Dark to be run by others, and so you will not be able to run it yourself."
        ]
      },
      {
        key: "shutdown",
        question: "I'm worried about vendor lock-in - what happens if Dark goes out of business?",
        answer: [
          "We're in this for the long haul, but if the worst should happen, we will open-source Dark, and will keep it running as long as possible so you can move off Dark.",
          "We're committed to codifying the specifics in a legal framework so that you can confidently use Dark, regardless of what the future holds."
        ]
      },
      {
        key: "export",
        question: "I'm worried about vendor lock-in - what happens if Dark stays in business but I still need to move off?",
        answer: [
          "We know that developers and companies will need to move off Dark for various reasons, and plan to support this. We have a couple of strategies planned, based on your needs.",
          "We currently support exporting your data using regular Dark tooling. We intend to create an exporter that will generate a readable Go or NodeJS application that matches the structure and intention of your Dark program, that you can host yourself. This will not be a perfect substitute, but it should greatly simplify your migration."
        ]
      },
      {
        key: "ip",
        question: "Who owns the code that I write in Dark, and the data that I and my users save in Dark?",
        answer: [
          "We do not currently have Terms of Service, and as a result, we do not currently claim any rights to your code or data.",
          "We will work on this shortly and intend to make clear that we do not claim any rights to your code and data beyond what is needed to host your application. We have not spoken to our lawyers, but we expect that regular copyright laws apply."
        ]
      }, {
        key: "community",
        question: "I want to write libraries for Dark - how can I take part in the Dark community/ecosystem?",
        answer: [
          "We'd love you to write Dark packages and take part in the community. Dark will have a package manager, where you'll be able to share code, libraries, handlers and datastores. We also plan to make our editor extensible, and allow you to create and share refactorings, visualizations and other tools."
        ]
      },
      {
        key: "version-control",
        question: "How does version control work in Dark?",
        answer: [
          "Dark removes the complexity of separate version control systems like git. Changes to your code are structured using feature flags, which conceptually unify version control, deployment, and enabling for users.",
          "We also support unlimited undo and redo on all code, though we do not currently support seeing a list of historical versions."
        ]
      },
      {
        key: "testing",
        question: "Will Dark support testing?",
        answer: [
          "Dark will have integrated unit testing for functions and handlers. We plan to generate tests for you based on types, and to trivially allow you to turn past requests into unit tests.",
          "It should also be possible to run integration tests that interact well with Dark - we plan to build features that support this use case."
        ]
      },
      {
        key: "deployless",
        question: "Deployless seems dangerous! Won't I constantly break my application?",
        answer: [
          "Dark is specifically designed to allow instant and safe deployment. When you write code in Dark, you can immediately see your changes, but that doesn't mean the changes are live for all users. With Dark's feature flags, you have precise control over how and when a specific feature or set of features becomes live, and for which part of your user base. You can test your changes as rigorously as makes sense for your usecase with the confidence that your development environment matches the production environment",
          [<p>Dark also supports code review and integration tests today. We plan to support unit testing, and as Dark grows, we will develop additional strategies and features to ensure that instant deployment is safe. To learn more about Dark's approach, read our <a target="_blank" rel="noopener noreferrer" href="https://medium.com/darklang/how-dark-deploys-code-in-50ms-771c6dd60671" className="light-purple paragraph-text MankSans-Medium">deployless blog post</a> and watch our <a href="/">launch video</a>.</p>]
        ]
      },
      {
        key: "offline",
        question: "Is it possible to write Dark code without being connected to the internet?",
        answer: [
          "Dark is designed for working in production, and the majority of our features and editing experience is tailored to that.",
          "However, we do plan to support using Dark on a plane or train, including handling synchronizations conflicts when you get back online. It's not going to be a great experience, since Dark is really designed for working in production, but it should work fine."
        ]
      },
      {
        key: "holistic",
        question: "I’m already invested in my editor, language, etc… Can I keep using them with Dark?",
        answer: [
          "No, and that's really the point of Dark. We believe that the important features in Dark are enabled because we have a holistic environment and we don't need to integrate with other languages, editors, and infrastructure. We discuss this in our \"Dark's philosophy\" launch video.",
        ]
      },
      {
        key: "3rdparty",
        question: "I have 3rd party and/or legacy systems that I need to use with my backend. Can I still use Dark?",
        answer: [
          "Yes. Dark speaks HTTP, and is designed to speak with 3rd-party services, vendors, and systems over HTTP. Today we support creating REST/JSON APIs that your other systems can use to speak with Dark, as well as making HTTP calls to other services from Dark.",
          "In the future, we plan to support GraphQL, gRPC, Thrift, TCP, UDP, and other protocols for working with your other systems. We also plan to support wrapping existing APIs and services in packages in our upcoming package manager."
        ]
      },
      {
        key: "compliance",
        question: "Are backends written in Dark compliant with GDPR/CCPA?",
        answer: [
          "Dark is not currently suitable for companies which must be compliant with various data privacy laws, including HIPAA, SOC2, GDPR and CCPA. We have designed Dark to support this sort of extensive end-user privacy (including access controls, audit logs, and special provisions for secrets and PII), but have not yet implemented these features in Dark.",
        ]
      },
      {
        key: "feature-x",
        question: "Does Dark support X?",
        answer: [
          "We are often asked whether Dark supports certain features in the language, editor and infrastructure. The way we think about this is that Dark is designed as a different way of writing software (namely, without infrastructure or deployment complexity). We believe that we have built a new foundation, and allowed something that wasn't possible before. We also believe that we can build almost anything on that foundation, but in most cases, we have not yet done so.",
          "That's a long way of saying that Dark probably doesn't yet support the feature you're asking about, but we believe we should be able to support it in the future. Generally, if there's a good reason for a thing, and an obvious way to build it, and it doesn't go against our core goals, we hope and plan to support it in the future."
        ]
      },
      /*
      {
        question: "",
        answer: [
          ""
        ]
      },
      {
        question: "",
        answer: [
          ""
        ]
      },
      {
        question: "",
        answer: [
          ""
        ]
      },
      {
        question: "",
        answer: [
          ""
        ]
      },
      {
        question: "",
        answer: [
          ""
        ]
      },
      {
        question: "",
        answer: [
          ""
        ]
      },
      {
        question: "",
        answer: [
          ""
        ]
      },
      {
        question: "",
        answer: [
          ""
        ]
      },
      {
        question: "",
        answer: [
          ""
        ]
      },
      {
        question: "",
        answer: [
          ""
        ]
      },
      {
        question: "",
        answer: [
          ""
        ]
      },
      {
        question: "",
        answer: [
          ""
        ]
      },

      */
    ]
  },
  tryDark
]

export { languagePageData }
